import React from "react";
import { ArrowRight } from "lucide-react";
import { universe } from "../mock";

export default function Universe() {
  return (
    <section className="relative overflow-hidden bg-[var(--crtr-cream)] py-24 md:py-32">
      <div className="mx-auto grid max-w-[1500px] items-center gap-14 px-5 md:grid-cols-[0.85fr_1.15fr] md:px-10">
        <div className="reveal">
          <span className="mono-label text-xs text-black/50">{universe.kicker}</span>
          <h2 className="font-display mt-4 text-6xl text-black sm:text-7xl">CRTR<br />UNIVERSE</h2>
          <div className="mt-6 space-y-1">
            {universe.title.map((t, i) => (
              <p key={i} className="font-heavy text-lg text-black/80">{t}</p>
            ))}
          </div>
          <span className="mt-8 inline-flex h-11 w-11 items-center justify-center rounded-full bg-[var(--crtr-yellow)]">
            <ArrowRight className="h-5 w-5 text-black" />
          </span>
        </div>

        <div className="reveal relative mx-auto aspect-square w-full max-w-[560px]">
          {/* center */}
          <div className="absolute left-1/2 top-1/2 z-20 flex h-24 w-40 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl bg-[var(--crtr-yellow)] px-5 shadow-xl">
            <img loading="lazy" src="/crtr-logo-long-black.png" alt="CRTR Studios" className="w-full object-contain" />
          </div>
          {universe.nodes.map((n, i) => {
            const angle = (i / universe.nodes.length) * Math.PI * 2 - Math.PI / 2;
            const r = 43;
            const x = 50 + r * Math.cos(angle);
            const y = 50 + r * Math.sin(angle);
            return (
              <div
                key={n.label}
                className="group absolute z-10 -translate-x-1/2 -translate-y-1/2"
                style={{ left: `${x}%`, top: `${y}%` }}
              >
                <div className="relative h-20 w-20 overflow-hidden rounded-full border-2 border-black/10 shadow-lg transition-transform duration-300 group-hover:scale-110 md:h-24 md:w-24">
                  <img loading="lazy" src={n.image} alt={n.label} className="h-full w-full object-cover" />
                </div>
                <span className="mono-label absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap text-[10px] text-black">{n.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
